var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 9.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 9.75,
    stroke: "#0017E7",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.8387C17.7419 15.8387 15.871 17.6774 15.871 19.9677C15.871 22.2581 17.7097 24.0968 20 24.0968C22.2903 24.0968 24.129 22.2258 24.129 19.9677C24.129 17.7097 22.2581 15.8387 20 15.8387ZM20 22.6129C18.5484 22.6129 17.3548 21.4194 17.3548 19.9677C17.3548 18.5161 18.5484 17.3226 20 17.3226C21.4516 17.3226 22.6452 18.5161 22.6452 19.9677C22.6452 21.4194 21.4516 22.6129 20 22.6129Z",
    fill: "#0017E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2903 16.6774C24.807 16.6774 25.2258 16.2586 25.2258 15.7419C25.2258 15.2253 24.807 14.8065 24.2903 14.8065C23.7737 14.8065 23.3548 15.2253 23.3548 15.7419C23.3548 16.2586 23.7737 16.6774 24.2903 16.6774Z",
    fill: "#0017E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7097 13.3226C25.871 12.4516 24.6774 12 23.3226 12H16.6774C13.871 12 12 13.871 12 16.6774V23.2903C12 24.6774 12.4516 25.871 13.3548 26.7419C14.2258 27.5806 15.3871 28 16.7097 28H23.2903C24.6774 28 25.8387 27.5484 26.6774 26.7419C27.5484 25.9032 28 24.7097 28 23.3226V16.6774C28 15.3226 27.5484 14.1613 26.7097 13.3226ZM26.5806 23.3226C26.5806 24.3226 26.2258 25.129 25.6452 25.6774C25.0645 26.2258 24.2581 26.5161 23.2903 26.5161H16.7097C15.7419 26.5161 14.9355 26.2258 14.3548 25.6774C13.7742 25.0968 13.4839 24.2903 13.4839 23.2903V16.6774C13.4839 15.7097 13.7742 14.9032 14.3548 14.3226C14.9032 13.7742 15.7419 13.4839 16.7097 13.4839H23.3548C24.3226 13.4839 25.129 13.7742 25.7097 14.3548C26.2581 14.9355 26.5806 15.7419 26.5806 16.6774V23.3226Z",
    fill: "#0017E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.c659d7e834700ce2c7d436de57f1808f.svg";
export { ForwardRef as ReactComponent };